export async function downloadFile(url: string, title: string): Promise<void> {
  await fetch(url, {
    method: 'GET',
  })
    .then(resp => resp.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob)
      const downloadTrigger = document.createElement('a')
      downloadTrigger.href = url
      downloadTrigger.download = title || new Date().getTime().toString()
      downloadTrigger.click()
      window.URL.revokeObjectURL(url)
    })
}
